module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Beth Wiseman\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Bestselling and award-winning author Beth Wiseman has sold over two million books. She is the recipient of the coveted Holt Medallion, is a two-time Carol Award winner, and has won the Inspirational Reader's Choice Award three times. Her books have been on various bestseller lists, including CBA, ECPA, Christianbook, and "), _c('I', [_vm._v("Publishers Weekly")]), _vm._v(". Beth and her husband are empty nesters enjoying country life in south-central Texas. Visit her online at BethWiseman.com; Facebook: @AuthorBethWiseman; Twitter: @BethWiseman; Instagram: @bethwisemanauthor")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/zuobGa/tc-custom/9781401689339.jpg?1703390233228",
      "alt": "This image is the cover for the book Choice to Forgive, Amish Christmas Novellas"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Choice to Forgive, Amish Christmas Novellas\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("After Daniel disappeared that long-ago Christmas Eve, Lydia built a life with his brother. But now she's a widow and Daniel has reappeared, asking for forgiveness. Can she go back to her normal life with her long-lost love as her neighbor?")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Thomas Nelson\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0